import React from "react";
import { LayoutGrid, Table2 } from "lucide-react";

import { Tabs, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { cn } from "@/lib/utils";

import type { ReportsListViewMode } from "../reportsListViewStorage";

export interface ReportsListViewToggleProps {
  value: ReportsListViewMode;
  onChange: (mode: ReportsListViewMode) => void;
  className?: string;
}

export function ReportsListViewToggle({
  value,
  onChange,
  className,
}: ReportsListViewToggleProps): React.ReactElement {
  return (
    <div data-reports-list-toolbar="" className={cn("shrink-0", className)}>
      <Tabs
        data-trade-log-tabs=""
        data-reports-view-toggle=""
        value={value}
        onValueChange={(next) => {
          if (next === "board" || next === "table") {
            onChange(next);
          }
        }}
        className="w-fit shrink-0"
      >
        <TabsList className="min-w-max">
          <TabsTrigger value="board" className="gap-1.5">
            <LayoutGrid className="size-3.5 shrink-0" aria-hidden />
            <span>Board</span>
          </TabsTrigger>
          <TabsTrigger value="table" className="gap-1.5">
            <Table2 className="size-3.5 shrink-0" aria-hidden />
            <span>Table</span>
          </TabsTrigger>
        </TabsList>
      </Tabs>
    </div>
  );
}
